/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateCampaignSettingsMutationRequest,
  UpdateCampaignSettingsMutationResponse,
  UpdateCampaignSettingsPathParams,
  UpdateCampaignSettings400,
} from '../types/UpdateCampaignSettings'

function getUpdateCampaignSettingsUrl({
  campaign_id,
}: {
  campaign_id: UpdateCampaignSettingsPathParams['campaign_id']
}) {
  const res = {
    method: 'PATCH',
    url: `/api/v1/emailbison/campaigns/${campaign_id}/settings/` as const,
  }
  return res
}

/**
 * @description Update campaign settings.
 * Request body (all fields optional):
 * name: string - Campaign name
 * max_emails_per_day: int - Maximum emails per day
 * max_new_leads_per_day: int - Maximum new leads per day
 * plain_text: bool - Use plain text emails
 * open_tracking: bool - Track email opens
 * can_unsubscribe: bool - Allow unsubscribe
 * @summary Update campaign settings
 * {@link /api/v1/emailbison/campaigns/:campaign_id/settings/}
 */
export async function updateCampaignSettings(
  {
    campaign_id,
  }: { campaign_id: UpdateCampaignSettingsPathParams['campaign_id'] },
  data?: UpdateCampaignSettingsMutationRequest,
  config: Partial<RequestConfig<UpdateCampaignSettingsMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateCampaignSettingsMutationResponse,
    ResponseErrorConfig<UpdateCampaignSettings400>,
    UpdateCampaignSettingsMutationRequest
  >({
    method: 'PATCH',
    url: getUpdateCampaignSettingsUrl({ campaign_id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
